module.exports = __webpack_public_path__ + "img/ml.7ea6123f.svg";